import { render, staticRenderFns } from "./edit-sound-dialog.vue?vue&type=template&id=27f2eb8f&scoped=true&"
import script from "./edit-sound-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-sound-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2eb8f",
  null
  
)

export default component.exports